module.exports = __webpack_public_path__ + "img/welcome_charts.b4d35978.png";